import "./CircularProgress.css";

const CircularProgress = () => {
  // NOT "loader" — public/index.css styles .loader for the static
  // pre-mount spinner and would bleed a blue border ring onto this
  return (
    <div className="circular-progress">
      <svg className="circular" viewBox="25 25 50 50">
        <circle
          className="track"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="4"
        ></circle>
        <circle
          className="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="4"
        ></circle>
      </svg>
    </div>
  );
};

export default CircularProgress;
